export var flexbox = {
  position: {
    justifyContent: function (position) {
      let className = 'd-flex justify-content-'

      switch (position) {
        case 'left':
          className += 'start'
          break
        case 'middle':
          className += 'center'
          break
        case 'right':
          className += 'end'
          break
        case 'around':
        case 'between':
          className += position
          break
      }

      return className
    }
  }
}

export function getFrontOfficeHelperStyle (hotelBackground = false) {
  let style = {}

  if (hotelBackground) {
    style = {
      backgroundImage: `url(${require('@/assets/img/loginBba.jpg')})`,
      backgroundRepeat: 'no-repeat',
      //backgroundSize: '100% auto',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
    }
  }

  return style
}
